import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * @param html - The HTML string to sanitize
 * @returns Sanitized HTML string safe for rendering
 */
export const sanitizeHtml = (html: string): string => {
  if (!html) return '';
  
  return DOMPurify.sanitize(html, {
    // Allow basic formatting tags but remove script, object, embed, etc.
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'i', 'b', 'a', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: ['href', 'target'],
    // Remove any protocols except http and https for links
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
  });
};

/**
 * Truncates text and then sanitizes it
 * @param text - The text to truncate and sanitize
 * @param maxLength - Maximum length of text
 * @returns Sanitized and truncated HTML string
 */
export const sanitizeAndTruncate = (text: string | undefined, maxLength: number): string => {
  if (!text) return '';
  
  const truncated = text.length > maxLength ? `${text.substring(0, maxLength)}[...]` : text;
  return sanitizeHtml(truncated);
};